import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  AddItem,
  InitAddStore,
  PagingChanged,
  RemoveItem,
  SearchFieldChanged,
  SelectAll,
  SelectNone,
} from '../actions/add-store.actions';
import {
  AddBrandsSuccess,
  AddClubsSuccess,
  AddCouponsetsCountSuccess,
  AddCouponsetsSuccess,
  AddStoreGroupsSuccess,
  AddUsersCountSuccess,
  AddUsersSuccess,
  CloseSidenav,
} from '../actions/edit-store.actions';
import { AddStoreState } from '../models/store.model';

const initialState: AddStoreState = {
  title: '',
  searchText: '',
  searchFilter: '',
  displayedColumns: {},
  tableData: '',
  totalResults: 0,
  paginator: {
    previousPageIndex: 0,
    pageIndex: 0,
    pageSize: 0,
    length: 0,
  },
  selectedItemsText: '',
  selectedItems: [],
  displayProperty: '',
};

export const AddStoreReducer = createReducer(
  initialState,
  on(
    InitAddStore,
    (
      state,
      { displayedColumns, displayProperty, title, selectedItemsText, searchText, selectedItems },
    ) => ({
      ...state,
      displayedColumns,
      displayProperty,
      title,
      selectedItemsText,
      searchText,
      selectedItems,
    }),
  ),
  on(SearchFieldChanged, (state, { searchFilter }) => ({
    ...state,
    searchFilter,
  })),
  on(AddStoreGroupsSuccess, (state, { res }) => ({
    ...state,
    tableData: res.payload.data,
    totalResults: res.payload.data.length,
  })),
  on(AddClubsSuccess, AddBrandsSuccess, (state, { res }) => ({
    ...state,
    tableData: res.payload.data,
    totalResults: res.payload.filterResults.totalResults,
  })),
  on(AddCouponsetsSuccess, (state, { res }) => ({
    ...state,
    tableData: res.payload.data,
  })),
  on(AddCouponsetsCountSuccess, (state, { totalResults }) => ({
    ...state,
    totalResults,
  })),
  on(AddUsersSuccess, (state, { res }) => ({
    ...state,
    tableData: res,
  })),
  on(AddUsersCountSuccess, (state, { totalResults }) => ({
    ...state,
    totalResults,
  })),
  on(PagingChanged, (state, { paginator }) => ({
    ...state,
    paginator,
  })),
  on(AddItem, (state, { item }) => {
    const itemExists = state.selectedItems.some(
      (oldItem) => oldItem[state.displayProperty] === item[state.displayProperty],
    );
    const updatedItems = itemExists
      ? state.selectedItems.filter(
          (oldItem) => oldItem[state.displayProperty] !== item[state.displayProperty],
        )
      : [...state.selectedItems, item];

    return {
      ...state,
      selectedItems: updatedItems,
    };
  }),
  on(RemoveItem, (state, { item }) => ({
    ...state,
    selectedItems: state.selectedItems.filter(
      (oldItem) => oldItem[state.displayProperty] !== item[state.displayProperty],
    ),
  })),
  on(SelectNone, (state) => {
    const updatedSelectedItems = state.selectedItems.filter(
      (selectedItem) =>
        !state.tableData.some(
          (tableItem: any) =>
            tableItem[state.displayProperty] === selectedItem[state.displayProperty],
        ),
    );

    return {
      ...state,
      selectedItems: updatedSelectedItems,
    };
  }),
  on(SelectAll, (state) => {
    const updatedSelectedItems = [
      ...state.selectedItems,
      ...state.tableData.filter(
        (tableItem: any) =>
          !state.selectedItems.some(
            (selectedItem) =>
              selectedItem[state.displayProperty] === tableItem[state.displayProperty],
          ),
      ),
    ];

    return {
      ...state,
      selectedItems: updatedSelectedItems,
    };
  }),
  on(ActiveComponentChanged, CloseSidenav, () => initialState),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
